export * from './MediaLibrary';
export * from './MediaPlaceholder';

export const IMAGE_SOURCE_PLACEHOLDER =
  'https://media.candulabs.com/static/source-image-placeholder.png';
